
import { Brain, Code, PenTool, BarChart3, MessageSquare, Database, Users, Search, ShoppingCart, FileText, Image, Briefcase, BookOpen, Zap, Heart, Film, Palette } from 'lucide-react';

export const categoryIcons = {
  "Productivity": Brain,
  "Development": Code,
  "Creative": PenTool,
  "Business": Briefcase,
  "Communication": MessageSquare,
  "Data Processing": Database,
  "Marketing": Users,
  "Research": Search,
  "E-commerce": ShoppingCart,
  "Documentation": FileText,
  "Media": Image,
  "Finance": Briefcase,
  "Education": BookOpen,
  "Writing": MessageSquare,
  "Data Analysis": Database,
  "Design": Palette,
  "Entertainment": Film,
  "Health": Heart
};
